import React from 'react';
import CTAButton from './CTAButton';

const LetterHero = () => {
  return (
    <header className="bg-bg-primary pt-20 pb-12 border-b border-slate-200">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="inline-block px-4 py-1.5 rounded-full bg-brand-gold/10 text-brand-gold font-bold text-xs uppercase tracking-widest mb-8">
          Special Retirement Report
        </div>
        
        <h1 className="text-4xl md:text-6xl font-display font-black text-brand-dark mb-8 leading-[1.15]">
          Simple Online Income For <span className="text-brand-gold underline decoration-brand-gold/30">Retirees</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-text-secondary leading-relaxed font-light italic mb-10">
          Beginner-friendly ways to earn flexible income from anywhere without complicated tech or risky investments
        </p>

        <div className="relative mb-12 max-w-3xl mx-auto">
          <div className="absolute -inset-4 bg-brand-gold/10 rounded-[3rem] blur-3xl"></div>
          <img 
            src="https://media-manager-c.questera.ai/greta-media/40a492dc43bc618e18a36c285588ccb1d2fe8075e2c19e16c3546447a7641f452c8a03ca0e53bb9227c01b726e9832ee/images/aW1hZ2UvcG5n/800a1e680cb5cadc0d9e1f5e00c048b5.png" 
            alt="Retiree couple using laptop in an RV" 
            className="relative w-full rounded-[2.5rem] shadow-premium border-[8px] border-white object-cover aspect-video"
          />
        </div>

        <div className="flex flex-col items-center gap-4 py-6 border-y border-slate-100">
          <p className="text-sm font-bold text-brand-dark uppercase tracking-[0.2em]">By Peter, Firefighter preparing for retirement</p>
        </div>
      </div>
    </header>
  );
};

export default LetterHero;